// The creature page's Rune Tablet card (shared/tablets.ts): which element its Coverage move casts, and the tablets
// in the bag that can change it. Shown only once the trainer holds a tablet or the creature carries one.
import { ELEMENT_IDS, ELEMENTS } from '../shared/elements.ts';
import { ITEM } from '../shared/items.ts';
import { MOVE, SLOT_LEVEL, speciesKit } from '../shared/moves.ts';
import { lineCoverageElement, tabletCheck, tabletItem } from '../shared/tablets.ts';
import type { CreatureDTO } from '../shared/protocol.ts';
import { S } from './state.ts';
import { iconUrl } from './assets.ts';
import { esc, full, elChip } from './fmt.ts';
import { isArmed } from './confirm.ts';

export function tabletCard(c: CreatureDTO): string {
  const t = S.trainer!;
  const held = ELEMENT_IDS.filter((el) => (t.bag[tabletItem(el)] ?? 0) > 0);
  if (!held.length && !c.tablet) return '';
  const mv = MOVE[speciesKit(c.species, c.tablet).coverage];
  const own = lineCoverageElement(c.species);
  const now = c.tablet
    ? `<p>Coverage: <b>${esc(mv.name)}</b> ${elChip(mv.element)} <span class="muted">· own ${esc(ELEMENTS[own].name)}</span></p>`
    : `<p>Coverage: <b>${esc(mv.name)}</b> ${elChip(mv.element)}</p>`;
  const late = c.level < SLOT_LEVEL.coverage ? `<p class="muted">Coverage at Lv ${SLOT_LEVEL.coverage}</p>` : '';
  const btns = held.map((el) => {
    const chk = tabletCheck(c, el), key = `tablet:${c.id}:${el}`, armed = isArmed(key);
    const label = armed ? `Confirm: use 1 ${ITEM[tabletItem(el)].name}` : `${el === own ? 'Back to' : 'Apply'} ${ELEMENTS[el].name} <small>${full(t.bag[tabletItem(el)] ?? 0)}</small>`;
    return `<button class="btn small${armed ? ' armed' : ''}" data-act="tablet" data-id="${c.id}" data-el="${el}"${chk.ok && !c.listed ? '' : ` disabled title="${esc(c.listed ? 'Listed for sale' : chk.why)}"`}><img class="ico16" src="${iconUrl(tabletItem(el))}" alt="">${label}</button>`;
  }).join('');
  return `<section class="panel cp-card"><div class="cp-h"><img class="cp-ico" src="${iconUrl(tabletItem(mv.element))}" alt=""><h5>Rune Tablet</h5>${c.tablet ? '<span class="pill">Tablet applied</span>' : ''}</div>
    ${now}${late}
    ${btns ? `<div class="row" style="flex-wrap:wrap">${btns}</div>` : ''}</section>`;
}
